import React, { useState } from 'react';
import { Link, NavLink } from "react-router-dom";
import CartFooter from "../common/CartFooter";
import { BsFillCreditCardFill } from "react-icons/bs";

function Pay() {

    return(
        <>
          <div className="container">
             <div className="cart-wrap">
                <div className="cartNav">
                    <ul>
                        <li><Link to="/cart">my shopping cart</Link></li>
                        <li><Link to="/patient-details">patient details</Link></li>
                        <li><Link className="active" to="/pay">pay</Link></li>
                    </ul>
                    <div className="cartClose"><img alt="" src={require('../images/icons/close.png')} /></div>
                </div>
                <div className="cart-list">
                    <h2 className="title left">Pay</h2>
                    <div className="payBox">
                        <h4 className="pb-2">pay now</h4>
                        <div className="payment-amount">
                        <label className="custom-radio">Full amount: <strong>£ 142.98</strong>
                            <input type="radio" name="radio"/>
                            <span className="checkmark"></span>
                        </label>
                        </div>
                        <div className="payment-amount">
                            <label className="custom-radio">Deposit: <strong>£ 28.60</strong> | At the clinic: <strong>£ 114.38</strong>
                                <input type="radio" name="radio"/>
                                <span className="checkmark"></span>
                            </label>
                        </div>
                        <div className="d-flex align-items-center warnMsg mt-4">
                            <img alt="" src={require('../images/icons/warning.png')} />
                            <p>With this option the products will be available for collection at the clinic. The deposit it’s <strong>non-refundable</strong>.</p>
                        </div>
                        <h4 className="pt-5">How do you wanna pay?</h4>
                        <div className="optPay">
                            <ul>
                                <li>
                                <label className="custom-radio bg check">
                                    <span className="radio-icon"><BsFillCreditCardFill/></span>
                                    <span className="inpTxt">Credit / Debit card</span>
                                    <input type="radio" name="radio2" checked />
                                    <span className="checkmark"></span>
                                </label>
                                </li>
                                <li>
                                <label className="custom-radio bg">
                                    <span className="radio-icon"><img alt="" src={require('../images/icons/google.png')} /></span>
                                    <span className="inpTxt">Pay with google</span>
                                    <input type="radio" name="radio2"/>
                                    <span className="checkmark"></span>
                                </label>
                                </li>
                                <li>
                                <label className="custom-radio bg">
                                    <span className="radio-icon"><img alt="" src={require('../images/icons/paypal.png')} /></span>
                                    <span className="inpTxt">Pay with paypal</span>
                                    <input type="radio" name="radio2"/>
                                    <span className="checkmark"></span>
                                </label>
                                </li>
                            </ul>
                        </div>

                        <div className="pt-4">
                            <div className="inp-wrap">
                                <label htmlFor="">Name on the card</label>
                                <input className="inp" type="text" placeholder="S Lucas" />
                            </div>
                            <div className="inp-wrap">
                                <label htmlFor="">Card number</label>
                                <input className="inp" type="text" placeholder="4242 4242 4242 4242" />
                            </div>
                            <div className="inp-wrap">
                                <label htmlFor="">Expiry Date</label>
                                <input className="inp" type="text" placeholder="DD/MM/YY" />
                            </div>
                            <div className="inp-wrap">
                                <label htmlFor="">CVV</label>
                                <input className="inp" type="text" placeholder="" />
                            </div>
                        </div>

                    </div>
                </div>
             </div>
          </div>

          <div className="cart-footer">
              <div className="container">
                  <div className="price-cont">
                    <span>Total price :</span>
                    <span>£ -</span>
                  </div>
                  <div className="priceButton">
                    <button className="themeBtn line">Cancel</button>
                    <Link to="/pay-success" className="themeBtn">Checkout</Link>
                  </div>
              </div>

              <CartFooter/>

          </div>


        </>
    )
}

export default Pay;